import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/src/components/ArticlesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/src/components/ContactFrontPageView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/src/components/ecommerce/products-gallery.tsx");
;
import(/* webpackMode: "eager" */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/src/components/icons/arrow-path-rounded-square.svg");
;
import(/* webpackMode: "eager" */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/src/components/icons/arrow-right.svg");
;
import(/* webpackMode: "eager" */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/src/components/icons/heart-solid.svg");
